import { Injectable, signal } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { JkEntityV2 } from './jkEntityV2';

// 目前沒有使用

@Injectable({
  providedIn: 'root',
})
export class JkTableService  {
  tableDataSource: MatTableDataSource<any>= new MatTableDataSource<any>([]); // TODO:改成signal. 應先將 srv.itemList 改成 signal
  srv!: JkEntityV2;
  displayedColumns: string[] = [];
  constructor() {
    //super();
  }
  init(srv:any,paginator: any, sort: any) {
    this.srv = srv;
    this.tableDataSource.data = srv.itemList(); //new MatTableDataSource<any>(srv.itemList());
    this.tableDataSource.paginator = paginator;
    if(sort){
      this.tableDataSource.sort = sort;
    }
  }

  applyFilter(event: Event) {
    if(!this.tableDataSource) return;
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }
  doRefresh(itemList: any[]) {
    if(!this.tableDataSource) return;
    if(this.tableDataSource && itemList){
      this.tableDataSource.data = itemList;
      if(this.displayedColumns.length == 0){
        alert('警告:jkTable.displayedColumns 未設定');
      }
    }
  }
  tableRowClick(item: any) {
    if(!this.srv) return;
    this.srv.item = item;
  }

}
